import { create } from 'zustand';

const LOCK_STORAGE_KEY = 'oms_idle_lock';

const getStoredLockState = () => {
  try {
    const stored = localStorage.getItem(LOCK_STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch {}
  return null;
};

const storedState = getStoredLockState();

export const useLockStore = create((set) => ({
  isLocked: !!storedState,
  lockedUser: storedState || null,

  lock: (user, timeoutMinutes = 3) => {
    const lockData = {
      email: user.email,
      full_name: user.full_name,
      timeoutMinutes,
    };
    localStorage.setItem(LOCK_STORAGE_KEY, JSON.stringify(lockData));
    set({ isLocked: true, lockedUser: lockData });
  },

  unlock: () => {
    localStorage.removeItem(LOCK_STORAGE_KEY);
    set({ isLocked: false, lockedUser: null });
  },
}));

// Cross-tab sync: when another tab locks/unlocks, update this tab's state
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === LOCK_STORAGE_KEY) {
      if (e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          useLockStore.setState({ isLocked: true, lockedUser: data });
        } catch {}
      } else {
        useLockStore.setState({ isLocked: false, lockedUser: null });
      }
    }
    // Also sync when auth tokens are cleared by another tab
    if (e.key === 'hr-auth-storage') {
      const lockData = localStorage.getItem(LOCK_STORAGE_KEY);
      if (lockData) {
        try {
          const data = JSON.parse(lockData);
          useLockStore.setState({ isLocked: true, lockedUser: data });
        } catch {}
      }
    }
  });

  // Safety net: periodically check localStorage in case storage event was missed
  setInterval(() => {
    const stored = getStoredLockState();
    const current = useLockStore.getState();
    if (stored && !current.isLocked) {
      useLockStore.setState({ isLocked: true, lockedUser: stored });
    } else if (!stored && current.isLocked) {
      useLockStore.setState({ isLocked: false, lockedUser: null });
    }
  }, 1000);
}
